import { ApiResponse } from "interface/response"
import { AxiosApi } from "./index";
import { FilterOption } from "interface";
import { PurchaseStatistic } from "interface/purchaseStatistic";
import { useInfoStore } from "store/error";

export interface PurchaseStatisticFilter extends FilterOption{
    buyerId?: string,
    buyerName?: string,
    vesselLedgerAccountNumber?: string,
    vesselName?: string
    vesselId?: string
}
export async function getPurchaseStaticsApi(filter: PurchaseStatisticFilter) {
    const apiUri = "PurchaseStatistic/";

    try {
        const menuResponse = await AxiosApi.get<ApiResponse<PurchaseStatistic[]>>(apiUri, {
            params: filter
        })
        return menuResponse.data.data
    } catch (error: any) {
          const { setError } = useInfoStore.getState();
          setError(error);
          throw  error
       }
}
